'use client';

import { useHtmlWithScripts } from '@/app/_lib/use-html-with-scripts';

interface DefaultHtmlRendererProps {
  html: string | undefined | null;
}

/**
 * Default renderer for HTML content with embedded scripts.
 * Uses useHtmlWithScripts to properly load and execute scripts
 * on client-side navigation.
 */
export function DefaultHtmlRenderer({ html }: DefaultHtmlRendererProps) {
  const { content } = useHtmlWithScripts(html);
  return <>{content}</>;
}
